const slider = document.querySelector('.research-custom__slider');
const prevButton = document.querySelector('.research-custom__navigation-prev');
const nextButton = document.querySelector('.research-custom__navigation-next');

if (slider) {
  let currentIndex = 0;
  const items = slider.querySelectorAll('.research-custom__item');

  if (items.length > 0) {
    items[0].classList.add('active');
  }
  //for buttons
  const updateButtonStates = () => {
    prevButton.classList.toggle('disabled', currentIndex === 0);
    nextButton.classList.toggle('disabled', currentIndex === items.length - 1);
  };

  updateButtonStates();

  prevButton.addEventListener('click', function () {
    if (currentIndex > 0) {
      items[currentIndex].classList.remove('active');
      currentIndex = (currentIndex - 1) % items.length;
      items[currentIndex].classList.add('active');
      updateButtonStates();
    }
  });

  nextButton.addEventListener('click', function () {
    if (currentIndex < items.length - 1) {
      items[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % items.length;
      items[currentIndex].classList.add('active');
      updateButtonStates();
    }
  });
}
